// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"60a1e29d","239":"e39fb35b","433":"94030528","455":"1b991356","977":"4b3215a8"}[chunkId] + ".chunk.js";
};